import { useMutation } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { nonEmptyStringOrDefault } from '../../../utils/variables';
import { LicenseForm } from './form';

type Props = {
  companyId: string;
  onError: (error: Error) => void;
  onSuccess: () => void;
  onMutate: () => void;
};

const useBuyQuery = (props: Props) =>
  useMutation({
    mutationFn: async (form: LicenseForm) =>
      SkyMapAxiosServiceFactory.instance.createUserServiceV0().buyDesignLicense({
        body: {
          companyId: props.companyId,
          invoiceEmail: form.invoiceEmail,
          invoiceReference: nonEmptyStringOrDefault(form.invoiceReference, undefined),
          invoiceTag: nonEmptyStringOrDefault(form.invoiceTag, undefined),
        },
      }),
    retry: false,
    networkMode: 'always',
    onError(error) {
      props.onError(error);
    },
    onSuccess() {
      props.onSuccess();
    },
    onMutate() {
      props.onMutate();
    },
  });

export { useBuyQuery };
